var map = {
	"./ads/mobile-app-store.svg": "2d2c",
	"./ads/mobile-google-play.svg": "31be",
	"./ads/mobile-single-apple.svg": "c31a",
	"./backgrounds/about-high-res.png": "d7e6",
	"./backgrounds/about-mobile.png": "f0fb",
	"./backgrounds/mobileApp.jpg": "df7d",
	"./decorations/dot-arrow.svg": "c009",
	"./decorations/hero-man.svg": "0e07",
	"./decorations/hero-phone.svg": "a6fc",
	"./decorations/hero-woman.svg": "c920",
	"./decorations/hospital.svg": "4b92",
	"./decorations/house.svg": "d916",
	"./decorations/map.svg": "f097",
	"./decorations/mobile-phones.svg": "d864",
	"./decorations/mobile-single-android.svg": "0315",
	"./decorations/mobile-single-apple.svg": "72ee",
	"./decorations/unicorn.gif": "4029",
	"./flags/pl.svg": "74ed",
	"./flags/ua.svg": "e899",
	"./flags/uk.svg": "bc8f",
	"./images/about-high-res.png": "2017",
	"./images/about-mobile.png": "496d",
	"./images/ewizyta.png": "e5d9",
	"./images/remote-tablet.png": "c772",
	"./logo/logo-color.svg": "e0b2",
	"./logo/logo-white.svg": "4718",
	"./logo/logo.svg": "ed29",
	"./logo/mobile-android-logo.svg": "fdb8",
	"./logo/mobile-apple-logo.svg": "08aa",
	"./logo/mydr-edm.svg": "2d9b",
	"./logo/przelewy24.svg": "198b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";